import { Injectable, Optional } from '@angular/core';
export class ObserverServiceConfig {
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
}

function ObserverServiceConfig_tsickle_Closure_declarations() {
/** @type {?} */
ObserverServiceConfig.prototype.root;
/** @type {?} */
ObserverServiceConfig.prototype.rootMargin;
/** @type {?} */
ObserverServiceConfig.prototype.threshold;
}


export type CallbackType = (inViewport: boolean) => void;

export interface WatchedItem {
  element: Element;
  callback: CallbackType;
}
export class ObserverService {
  options: ObserverServiceConfig = {
    rootMargin: '0px',
    threshold: 0.1
  };

  supported = false;

  watching: Array<WatchedItem> = [];

  observer: IntersectionObserver | null;
/**
 * Assigns the user config if they wish to
 * override the defaults by using forRoot
 * @param {?} config
 */
constructor( config: ObserverServiceConfig) {
    this.supported = 'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window;
    if (config) {
      this.options = Object.assign({}, this.options, config);
    }

    this.observer = this.supported ? new IntersectionObserver(this.handleEvent.bind(this), this.options) : null;
  }
/**
 * Handles events made by the observer
 * @param {?} entries
 * @return {?}
 */
handleEvent(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry: IntersectionObserverEntry) => {
      const /** @type {?} */ target = this.watching.find((element) => {
        return element.element === entry.target;
      });

      if (entry.isIntersecting) {
        this.observer.unobserve(entry.target);

        target.callback(true);
      }
    });
  }
/**
 * Adds the target to our array so we can call its
 * call back when it enters the viewport
 * @param {?} el
 * @param {?} callback
 * @return {?}
 */
addTarget(el: Element, callback: CallbackType): void {
    this.observer.observe(el);

    this.watching.push({
      element: el,
      callback: callback
    });
  }
/**
 * @return {?}
 */
isSupported() {
    return this.supported;
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ObserverServiceConfig, decorators: [{ type: Optional }, ]},
];
}

function ObserverService_tsickle_Closure_declarations() {
/** @type {?} */
ObserverService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ObserverService.ctorParameters;
/** @type {?} */
ObserverService.prototype.options;
/** @type {?} */
ObserverService.prototype.supported;
/** @type {?} */
ObserverService.prototype.watching;
/** @type {?} */
ObserverService.prototype.observer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
